/* Theme-owned web events. Checkout/purchase remain owned by the Shopify pixel. */
(() => {
  if (window.JumboAnalytics) return;
  const listName = sku => {
    try { return window.productListManager?.getCollectionTitleById(String(sku)) || 'no list'; }
    catch (_) { return 'no list'; }
  };
  const push = (event, ecommerce) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({ event, ecommerce });
  };
  const interaction = (event, fields) => {
    window.dataLayer = window.dataLayer || [];
    if (fields.ecommerce) window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({ event, ...fields });
  };
  const trackItems = (event, items, currency = 'TRY') => {
    if (!items.length) return;
    push(event, {
      currency,
      value: Math.round(items.reduce((sum, item) => sum + item.price * item.quantity, 0) * 100) / 100,
      items
    });
  };
  const error = (action, label) => {
    window.dataLayer = window.dataLayer || [];
    // Labels are fixed codes: never send form values, API responses or stack traces.
    window.dataLayer.push({ event: 'all_errors', event_category: 'Error Events', event_action: action, event_label: label });
  };
  const productItem = element => {
    const d = element.dataset;
    const price = Number(d.productPrice) || 0;
    const discount = Number(d.productDiscount) || 0;
    return {
      item_id: d.productId, item_name: d.productName, price, discount,
      item_brand: d.productBrand || 'Jumbo',
      item_category: d.productCategory || '', item_category2: d.productCategory2 || '',
      item_category3: d.productCategory3 || '', item_category4: d.productCategory4 || '', item_category5: d.productCategory5 || '',
      quantity: 1, item_list_id: 'Listeleme', item_list_name: listName(d.productId),
      item_variant: d.productVariant || '', item_first_price: price + discount,
      item_sale_rate: '%' + (price + discount > 0 ? Math.floor(discount / (price + discount) * 100) : 0),
      item_stock: d.stock, item_image: d.productImage, item_previous_id: d.productPreviousId || ''
    };
  };
  const cartItems = root => root ? [...root.querySelectorAll('[data-ga-cart-item]')].flatMap(element => {
    try {
      const item = JSON.parse(element.dataset.gaCartItem);
      item.item_list_name = listName(item.item_id);
      return [item];
    } catch (_) { return []; }
  }) : [];
  const viewCart = root => {
    if (!root) return;
    const items = cartItems(root);
    // Empty cart views are useful too, with value 0 and an empty items array.
    push('view_cart', {
      currency: root.querySelector('[data-product-currency]')?.dataset.productCurrency || window.Shopify?.currency?.active || 'TRY',
      value: Math.round(items.reduce((sum, item) => sum + item.price * item.quantity, 0) * 100) / 100,
      items
    });
  };
  window.JumboAnalytics = { push, interaction, trackItems, error, productItem, cartItems, viewCart, listName };

  const viewedProducts = new WeakMap();
  const viewProduct = () => {
    document.querySelectorAll('[data-main-product]').forEach(element => {
      const key = element.dataset.productVariantId || element.dataset.productId;
      if (viewedProducts.get(element) === key) return;
      viewedProducts.set(element, key);
      trackItems('view_item', [productItem(element)], element.dataset.productCurrency || 'TRY');
    });
  };

  const seenPromotions = new Set();
  const observedPromotions = new WeakSet();
  const promotionItem = element => {
    const d = element.dataset;
    const image = element.querySelector('img');
    return { promotion_id: d.gaPromotion, promotion_name: d.gaPromotionName,
      creative_slot: d.gaPromotionSlot, creative_name: image?.currentSrc || image?.src || d.gaPromotionCreative || '' };
  };
  const viewPromotion = element => {
    if (element.closest('[data-clone], [aria-hidden="true"]')) return;
    const key = element.dataset.gaPromotion + ':' + element.dataset.gaPromotionSlot;
    if (seenPromotions.has(key)) return;
    seenPromotions.add(key);
    push('view_promotion', { items: [promotionItem(element)] });
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.isIntersecting && entry.intersectionRatio >= 0.1) viewPromotion(entry.target); });
  }, { threshold: [0.1] }) : null;
  const setupPromotions = () => {
    document.querySelectorAll('[data-ga-promotion]:not([data-clone])').forEach(element => {
      if (observedPromotions.has(element)) return;
      observedPromotions.add(element);
      if (observer) observer.observe(element);
      else viewPromotion(element);
    });
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    const promotion = link?.closest('[data-ga-promotion]');
    if (!promotion || !link.getAttribute('href') || link.getAttribute('href') === '#') return;
    push('select_promotion', { items: [promotionItem(promotion)] });
  });
  document.addEventListener('jumbo:pdp:variant', viewProduct);
  document.addEventListener('theme:cart:open', () => viewCart(document.querySelector('[data-cart-drawer]')));
  document.addEventListener('shopify:section:load', () => { setupPromotions(); viewProduct(); });

  // New components use explicit hooks. Keep the existing GTM listeners on legacy components.
  const text = element => (element?.textContent || '').replace(/\s+/g, ' ').trim();
  document.addEventListener('click', event => {
    const target = event.target;
    const detail = target.closest('[data-pdp-info-tab], [data-pdp-toggle], [data-share]');
    const product = detail && document.querySelector('[data-main-product]');
    if (detail) interaction('product_detail_interactions', {
      event_category: 'Ürün Detay', event_action: detail.matches('[data-share]') ? 'Paylaş Click' : 'Click',
      event_label: detail.getAttribute('aria-label') || text(detail),
      // Existing GTM product_name/product_id variables read ecommerce.items.0.
      ...(product ? { ecommerce: { items: [productItem(product)] } } : {})
    });
    const category = target.closest('[data-quick-links] .quick-links__item');
    if (category) interaction('category_slide_click', {
      event_category: 'Kategori Slide Tıklaması', event_action: 'Click',
      event_label: text(category), event_img: category.querySelector('img')?.currentSrc || '',
      event_href: category.getAttribute('href'),
      slide_count: 'slot-' + ([...category.parentElement.children].indexOf(category) + 1)
    });
    const filter = target.closest('[data-filter-dropdown], .collection__filter__title, .filter__button, .collection__sort__button, [data-filter-reset-button], .plp-active-chip');
    if (filter && !filter.hasAttribute('data-listener-added')) {
      const option = filter.matches('.filter__button');
      const action = option ? 'Filter Clicks' : filter.matches('.collection__sort__button') ? 'Sort Clicks' :
        filter.matches('[data-filter-reset-button], .plp-active-chip') ? 'Remove Filters' : 'Main Click';
      interaction('filter_interactions', { event_category: 'Listeleme', event_action: action,
        event_label: text(filter), event_header: option ? text(filter.closest('.collection__filter, [data-dropdown-container]')?.querySelector('button')) : '' });
    }
    if (target.closest('.msearch__input, .mh__search-input')) interaction('search_actions', {
      event_category: 'Search Bar Click', event_action: 'Click'
    });
    // Suggestion buttons inside lists already have delegated listeners in GTM.
  });
  const listResult = (initial = false) => {
    const count = document.querySelector('[data-products-count]');
    const breadcrumb = document.querySelector('.breadcrumbs');
    if (!count || !breadcrumb) return;
    // The published GTM container already emits the initial event when both exact selectors match.
    if (initial && count.className === 'text-sm ml-auto whitespace-nowrap h-full flex items-center justify-center' && breadcrumb.className === 'breadcrumbs ') return;
    interaction('list_breadcrumb_result', { event_category: 'Listeleme', event_action: 'List Result',
      event_label: count.dataset.productsCount || text(count),
      full_breadcrumb: [...breadcrumb.querySelectorAll('.breadcrumbs__link, .breadcrumbs__current')].map(text).filter(Boolean).join('>') });
  };
  document.addEventListener('theme:filters:init', () => listResult());

  // Browser validation failures, deduplicated per form submission tick.
  const invalidForms = new WeakSet();
  document.addEventListener('invalid', event => {
    const form = event.target.form;
    if (!form || invalidForms.has(form)) return;
    invalidForms.add(form);
    error('Form Error', 'Validation failed');
    setTimeout(() => invalidForms.delete(form), 0);
  }, true);
  window.addEventListener('error', event => {
    if (!event.error || !event.filename) return;
    try {
      const source = new URL(event.filename, window.location.href);
      if (source.origin === window.location.origin && source.pathname.includes('/assets/')) error('JavaScript Error', 'Theme script error');
    } catch (_) { /* Ignore third-party and invalid URLs. */ }
  });
  const init = () => {
    viewProduct(); setupPromotions(); viewCart(document.querySelector('[data-cart-page]')); listResult(true);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
